
export default class DeliveryDisAccordRouteDetail {
  constructor(actualdetail?: DeliveryDisAccordRouteDetail) {
    if (actualdetail) {
      Object.entries(actualdetail).forEach(([key, value]) => {
        this[key] = value
      })
    }
  }
  /**
    * 交接单号
    */
  deliveryReceiptNo?: string;

  /**
   * 主单号
   */
  waybillNo?: string;
  /**
   * 子单号
   */
  subBillNo?: string;

  /**
   * 扫描时间
   */
  scanTime?: string;

  /**
   * 交接单提交时间
   */
  deliveryReceiptSubmitTime?: string;

  /**
   * 票数
   */
  //    private int ticket;
  /**
   * 件数
   */
  //    private int piece;
  /**
   * 结算重量
   */
  calcWeight?: string;


  /**
   * 装车分拨
   */
  loadCenter?: string;
  /**
   * 装车分拨编码
   */
  loadCenterCode?: string;
  /**
   * 装车片区
   */
  loadArea?: string;
  /**
   * 装车大区
   */
  loadBigArea?: string;
  /**
   * 装车省区
   */
  loadProvinceArea?: string;
  /**
   * 装车区域
   */
  loadRegion?: string;
  /**
   * 装车省区
   */
  loadProvince?: string;
  /**
   * 装车城市
   */
  loadCity?: string;
  /**
   * 装车区县
   */
  loadCounty?: string;

  /**
   * 计划下一站分拨中心
   */
  planNextCenter?: string;
  /**
   * 计划下一站分拨编码
   */
  planNextCenterCode?: string;
  /**
   * 计划下一站片区
   */
  planNextArea?: string;
  /**
   * 计划下一站大区
   */
  planNextBigArea?: string;
  /**
   * 计划下一站省区
   */
  planNextProvinceArea?: string;
  /**
   * 计划下一站区域
   */
  planNextRegion?: string;
  /**
   * 计划下一站省份
   */
  planNextProvince?: string;
  /**
   * 计划下一站城市
   */
  planNextCity?: string;
  /**
   * 计划一下站区县
   */
  planNextCounty?: string;
  /**
   * 计划路由
   */
  planRoutePath?: string;


  /**
   * 实际下一站分拨
   */
  actualNextCenter?: string;
  /**
   * 实际下一站分拨编码
   */
  actualNextCenterCode?: string;
  /**
   * 实际下一站片区
   */
  actualNextArea?: string;
  /**
   * 实际下一站大区
   */
  actualNextBigArea?: string;
  /**
   * 实际下一站省区
   */
  actualNextProvinceArea?: string;
  /**
   * 实际下一站区域
   */
  actualNextRegion?: string;
  /**
   * 实际下一站省份
   */
  actualNextProvince?: string;
  /**
   * 实际下一站城市
   */
  actualNextCity?: string;
  /**
   * 实际下一站县区
   */
  actualNextCounty?: string;
  /**
   * 错分后路径
   */
  actualRoutePath?: string;


  /**
   * 时效差异(h)
   */
  timeDifference?: string;
  /**
   * 装车人工号
   */
  loadWorkerNo?: string;
  /**
   * 装车姓名
   */
  loadWorkerName?: string;


  /**
   * 产品类型
   */
  productType?: string;
  /**
   * 产品时效
   */
  lengthOfTime?: string;
  /**
   * 产品优势
   */
  superiorityProduct?: string;

  /**
   * 当前系统时间
   */
  currentSystemTime?: string;

  /**
   * 备注 记录
   */
  remark?: string;

}
